import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultGuestsOptions = {
    actionLocation: undef,
    adultsMax: undef,
    adultsMin: undef,
    allowErrorHighlighting: undef,
    autoSubmit: undef,
    centered: undef,
    childrenMax: undef,
    childrenMin: undef,
    disableTextInput: undef,
    fadeOut: false,
    fadeOutDuration: 0,
    id: 'guests',
    inputIconName: 'group',
    name: 'guests',
    placement: 'bottom',
    positionIconRight: undef,
    showClearButton: false,
    showContinue: undef,
    showInputIcon: undef,
    showPetOption: true,
    wdioPrefix: undef
};

function useGuestsOptions(props) {
    const {
        guestsOptions: propsGuestsOptions
    } = props;

    const {
        options: guestsOptions
    } = useOptions(defaultGuestsOptions, propsGuestsOptions);

    const result = {
        guestsOptions
    };

    useDebugValue(result);

    return result;
}

export {useGuestsOptions};
